// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"650":"5d15c2bf74f663c1","883":"7d9ee5013f987c17"}[chunkId] + ".js";
};